import { Button, Col, Row, Tabs } from 'antd';
import { FC, useState } from 'react';
import BookingsTable from './Table';
import Calendar from './calendar';
import { Plus } from 'react-iconly';
import BreadCrumbs from '../../../layout/components/content/breadcrumbs';
import { getUserData } from '../../../api/auth';
import { useAggregatedBookings } from './useBookings';
import BookForm from './bookings-form';

const BookingsView: FC = () => {
  const [creatingBooking, setCreatingBooking] = useState(false);

  const useBookings = useAggregatedBookings();

  const userData = getUserData();

  const canUpdateRent =
    userData?.permissions.includes('booking:update') || userData?.isAdmin;

  return (
    <>
      <Row gutter={[32, 32]} className='hp-ecommerce-app hp-mb-32'>
        <Col span={24}>
          <Row gutter={[32, 32]} justify='space-between'>
            <BreadCrumbs
              breadCrumbParent='Applications'
              breadCrumbParent2='Cockpit'
              breadCrumbActive='Bookings'
            />

            {canUpdateRent && (
              <Col span={24} md={12}>
                <Row
                  gutter={[16, 16]}
                  justify='end'
                  className='hp-ecommerce-app-inventory-events'
                >
                  <Col>
                    <Row
                      gutter={[16, 16]}
                      justify='end'
                      className='hp-ecommerce-app-inventory-events'
                    >
                      <Col>
                        <Button
                          type='primary'
                          onClick={() => setCreatingBooking(true)}
                        >
                          <Plus set='curved' size={18} />
                          <span className='hp-ml-8'>Novo Marcação</span>
                        </Button>
                      </Col>
                      {creatingBooking && (
                        <BookForm
                          open={creatingBooking}
                          handleCancel={() => setCreatingBooking(false)}
                        />
                      )}
                    </Row>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
          <Row
            gutter={[16, 16]}
            justify='space-between'
            className='hp-mt-8 hp-ecommerce-app-inventory-events'
          >
            <h2>Marcações</h2>
          </Row>
        </Col>
      </Row>

      <Tabs defaultActiveKey='1'>
        <Tabs.TabPane tab='Lista' key='1'>
          <BookingsTable />
        </Tabs.TabPane>
        <Tabs.TabPane tab='Calendário' key='2'>
          <Calendar bookingsQuery={useBookings.bookingsQuery} />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};

export default BookingsView;
